import SmartStatusIcon from "Assets/Image/smart-status-logo-sm.png";

export const SITE_CONFIG = Object.freeze({
  siteName: "BSmart Status",
  siteIcon: SmartStatusIcon,
  footerText: "BSmart Status ©2024 Created by Openxcell Inc",
});

export const DASHBOARD_KEY = "dashboard";

export const PAGINATION = Object.freeze({ PER_PAGE: 10 });

export const FORM_PARAMS = Object.freeze({
  LABEL_COL_SPAN: 5,
  LABEL_COL_SPAN_L: 6,
  LABEL_COL_SPAN_XL: 7,
});

export const REGEX = Object.freeze({
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?"':;{}|<>/\\_-]).{8,}$/,
  // PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W|_).{8,}$/,
  NUMBER: /[^0-9-]/g,
  FLOAT_NUMBER: /[^0-9+.]/g,
  MULTIPLE_PHONE_NO: /[^0-9-, ]/g,
});

export const MODAL_TYPE = Object.freeze({
  ADD: "Add",
  EDIT: "Edit",
  VIEW: "View",
});

export const QUESTION_TYPE = Object.freeze({
  TEXT: "Text",
  SINGLE_CHOICE: "Single_Selection",
  MULTIPLE_CHOICE: "Multiple_Selection",
});

export const HEALTH_ASSESSMENT_QUESTION_TYPE = Object.freeze({
  SINGLE_CHOICE: "Single_Selection",
  SUB_QUESTION: "Sub_Question",
})

export const QUESTION_TYPE_ARRAY = [
  {
    value: QUESTION_TYPE.TEXT,
    label: "Text",
  },
  {
    value: QUESTION_TYPE.SINGLE_CHOICE,
    label: "Single Selection",
  },
  {
    value: QUESTION_TYPE.MULTIPLE_CHOICE,
    label: "Multiple Selection",
  },
];

export const QUESTION_RADIO_VALUE = Object.freeze({
  IS_DATE_NEEDED: "is_date_needed",
  IS_TEXT_NEEDED: "is_text_needed",
});

export const DATE_FORMAT = Object.freeze({
  DD_MM_YYYY: "DD/MM/YYYY",
});

export const IMG_FALLBACK_VALUE =
  "data:image/png;base64,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";

export const GENDER_TYPE = Object.freeze({
  MALE: "MALE",
  FEMALE: "FEMALE",
  OTHER: "OTHER",
});

export const FORMATS = [
  "header",
  "font",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "script",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  // "formula",
  "color",
  "background",
  "align",
  // "size",
  "clean",
];

export const MODULES = Object.freeze({
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }, { font: [] }],
    //   [{ font: Font.whitelist }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ script: "sub" }, { script: "super" }],
    [{ align: ["right", "center", "justify"] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    [{ color: [] }],
    [{ background: [] }],
    // [{ size: ["small", false, "large", "huge"] }],
    ["clean"],
  ],
  clipboard: {
    matchVisual: false,
  },
});

export const DEBOUNCE_TIME = 2000;

export const ADMIN_TYPE = Object.freeze({
  ADMIN: "admin",
  SUB_ADMIN: "sub-admin",
});

export const AGE_RANGE = Object.freeze({
  UNDER_18_YEARS: "UNDER_18_YEARS",
  YEARS_18_TO_24: "YEARS_18_TO_24",
  YEARS_25_TO_29: "YEARS_25_TO_29",
  YEARS_30_TO_36: "YEARS_30_TO_36",
  YEARS_37_TO_42: "YEARS_37_TO_42",
  YEARS_43_TO_49: "YEARS_43_TO_49",
  YEARS_50_TO_65: "YEARS_50_TO_65",
  OVER_65_YEARS: "OVER_65_YEARS",
});

export const AGE_RANGE_OPTIONS = [
  { value: "UNDER_18_YEARS", label: "Under 18" },
  { value: "YEARS_18_TO_24", label: "18 to 24" },
  { value: "YEARS_25_TO_29", label: "25 to 29" },
  { value: "YEARS_30_TO_36", label: "30 to 36" },
  { value: "YEARS_37_TO_42", label: "37 to 42" },
  { value: "YEARS_43_TO_49", label: "43 to 49" },
  { value: "YEARS_50_TO_65", label: "50 to 65" },
  { value: "OVER_65_YEARS", label: "Over 65" },
];

export const DIRECTORY_SERVICES = Object.freeze({
  HIV_TESTING: "HIV Testing",
  HIV_TREATMENT: "HIV Treatment",
  COUNSELLING_AND_PREVENTION: "Counselling and Prevention",
  ANTIRETROVIRALS_DISPENSED: "Antiretrovirals (ARVs) Dispensed",
  HIV_PREVENTION: "HIV Prevention",
});

export const MONTHS = [1, 3, 6, 12];
export const CUSTOM = "Custom";

export const EXPORT_REPORT_NAME = Object.freeze({
  FEED_DETAILS_SHEET: "Feed Details",
  FEED_TOPIC_BY_DATE_SHEET: "Feed Topics by Date",
  ACTIVE_USER: "Active Users",
  SESSION_LENGTH: "Session length",
  SCREEN_VIEWS: "Screen views",
  RETENTION_RATE: "Retention rate",
  QUICK_GUIDE_POST_REPORT: "Quick guide Post report",
  QUICK_GUIDE_LINK_REPORT: "Quick guide Link report",
  SEARCH_QUICK_GUIDE_REPORT: "Search Quick guide report",
  SEARCH_DIRECTORY_REPORT: "Search Directory report",
  CONSOLIDATE_METRICS: "Consolidate metrics",
});

export const DASHBOARD_CHART = Object.freeze({
  ACTIVE_USER: "No of active users",
  SESSION_LENGTH: "Session length",
  SCREEN_VIEWS: "Screen views",
  RETENTION_RATE: "Retention rate",
  CONSOLIDATE_METRICS: "Consolidate metrics",
});

export const SCREENING_TOOL_CHART = Object.freeze({
  TEST_COMPLETED: "Tests Completed",
  TEST_INITIATED: "Tests Initiated",
  AVERAGE_TIME: "Average Time",
  CONSOLIDATE_METRICS: "Consolidate metrics",
  ANSWER_DISTRIBUTION: "Answer Distribution",
});

export const HEALTH_ASSESSMENT_CHART = Object.freeze({
  TEST_COMPLETED: "Tests Completed",
  TEST_INITIATED: "Tests Initiated",
  RESULT_METRICS: "Result Metrics",
  ANSWER_DISTRIBUTION: "Answer Distribution",
  AVERAGE_TIME: "Average Time",
  CONSOLIDATE_METRICS: "Consolidate metrics",
});

export const DEFAULT_CSV_FILE_NAME = "SmartStatusReport.xlsx";

export const STATIC_PAGE_PARAMS = Object.freeze({
  TERM_AND_CONDITIONS: "terms-and-conditions",
  PRIVACY_POLICY: "privacy-policy",
});


export const TEMPLATE_TYPE = Object.freeze({
  EVENT: "EVENT",
  BROADCAST_NOTIFICATION_HEALTH_MINISTRY: "BROADCAST_NOTIFICATION_HEALTH_MINISTRY",
  BROADCAST_CUSTOM_NOTIFICATION: "BROADCAST_CUSTOM_NOTIFICATION",
})